export default "__VITE_ASSET__BIxqNYaE__"